import { render, staticRenderFns } from "./ShippingDashboard.vue?vue&type=template&id=74656b08&"
import script from "./ShippingDashboard.vue?vue&type=script&lang=js&"
export * from "./ShippingDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ShippingDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports